var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.94.6c.625 0 1.105.192 1.44.576.385.384.577.864.577 1.44v46.08c0 .72-.216 1.296-.648 1.728-.432.384-.96.576-1.584.576-.336 0-.672-.072-1.008-.216a2.74 2.74 0 01-.72-.504L4.109 8.664v40.392c0 .528-.216.984-.648 1.368-.384.384-.84.576-1.368.576-.576 0-1.056-.192-1.44-.576a1.869 1.869 0 01-.576-1.368V2.76c0-.672.192-1.2.576-1.584A2.205 2.205 0 012.165.6c.768 0 1.344.264 1.728.792l31.032 41.832V2.616c0-.576.192-1.056.576-1.44.384-.384.864-.576 1.44-.576z",
    fill: "currentColor"
  })));
}
export default SvgN;